// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__2boAo","Input":"Form_Input__1kIqz","Button":"Form_Button__1q5fL"};